export const CREATE_ACCOUNT = 'CREATE_ACCOUNT'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const FORGOTPASSWORD = 'FORGOTPASSWORD'
export const RESETPASSWORD = 'RESETPASSWORD'
